// removed by extract-text-webpack-plugin
module.exports = {"common-radio":"common-radio"};


//////////////////
// WEBPACK FOOTER
// ./src/widget/Radio/index.less
// module id = 909
// module chunks = 367